// Localhost
export const localHostname: string = "localhost";
export const localAPIRoot: string = "https://" + localHostname + ":6001";
export const localWebSocketHostName: string = "wss://" + localHostname + ":6001";

// Dev 01
export const development01Hostname: string = "34.200.21.158";
export const development01APIRoot: string =
  "https://" + development01Hostname + "/gateway";

// Dev 01: Load Balanced
export const developmentLoadBalancedHostname: string =
  "dev-lb-external-1538137222.us-east-1.elb.amazonaws.com";
export const developmentLoadBalancedAPIRoot: string =
  "https://" + developmentLoadBalancedHostname + "/gateway";

// Demo
export const demoHostname1: string = "54.221.99.96";
export const demoAPIRoot1: string = "https://" + demoHostname1 + "/gateway";

export const demoPartialHostname: string = ".vgdemo.org";
export const demoDynamicAPIRoot = (domain: string) : string => {
  return `https://${domain}${demoPartialHostname}/gateway`;
};

// DR
export const drHostname: string = "35.163.140.50";
export const drAPIRoot: string = "https://" + drHostname + "/gateway";

// Staging
export const stagingHostname: string = "44.199.169.114";
export const stagingAPIRoot: string = "https://" + stagingHostname + "/gateway";

// Staging-Keycloak
export const stagingKeycloakHostname: string = "3.82.169.48";
export const stagingKeycloakAPIRoot: string = "https://" + stagingKeycloakHostname + "/gateway";

// Production: Load Balanced
export const productionLoadBalancedHostname: string =
  "prod-lb-external-938615202.us-east-1.elb.amazonaws.com";
export const productionLoadBalanceAPIRoot: string =
  "https://" + productionLoadBalancedHostname + "/gateway";

export const productionPartialHostname: string = ".verificationgateway.org";
export const productionDynamicAPIRoot = (domain: string): string => {
  return `https://${domain}${productionPartialHostname}/gateway`;
};
